$('.navbar-fullscreen-close').click(function(event){
  event.preventDefault();
  let dropdown = $(this).closest('.uk-dropdown');
  // Argument for hide is delay time
  UIkit.dropdown(dropdown).hide(0);
});
